import { render, staticRenderFns } from "./mis-datos-academicos.vue?vue&type=template&id=86f5d14e&scoped=true"
import script from "./mis-datos-academicos.vue?vue&type=script&lang=js"
export * from "./mis-datos-academicos.vue?vue&type=script&lang=js"
import style0 from "./mis-datos-academicos.vue?vue&type=style&index=0&id=86f5d14e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f5d14e",
  null
  
)

export default component.exports